import Marquee from "react-fast-marquee";

const ITEMS = ["Música", "Experiência", "Memória", "LC Production", "Cerimônia", "Festa"];

const EditorialMarquee = () => (
    <div className="border-y border-black/10 py-8 md:py-12 overflow-hidden bg-white" data-testid="editorial-marquee">
        <Marquee speed={35} gradient={false}>
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span
                        className={`text-5xl md:text-7xl mx-8 md:mx-14 whitespace-nowrap ${
                            i % 2 === 0
                                ? "font-extrabold uppercase tracking-tight text-[#0A0A0A]/[0.08]"
                                : "font-editorial italic font-light text-[#6A2022]/30"
                        }`}
                    >
                        {item}
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#6A2022]" />
                </span>
            ))}
        </Marquee>
    </div>
);

export default EditorialMarquee;
